import { useRef } from 'react';
import ReactDOM from 'react-dom';
import { BigButton } from '../BigButton';

import { AnimatePresence } from 'framer-motion';
import animations from '../../helpers/animations';
import { useModalAuthStore } from '../../store/auth/authModalStore';
import {
    BackgroundModal,
    ButtonsWrap,
    ModalContent,
    ModalWrapper,
    RemovingElementWrap,
} from './styles';

export const ModalLoginNotice = ({
    isVisible,
    setVisible,
}: {
    isVisible: boolean;
    setVisible: (d: boolean) => void;
}) => {
    const { setIsVisibleAuthModal } = useModalAuthStore();

    const modalRef = useRef<HTMLDivElement | null>(null);

    return ReactDOM.createPortal(
        <AnimatePresence>
            {isVisible && (
                <BackgroundModal
                    ref={modalRef}
                    onClick={() => setVisible(false)}
                    {...animations.calendar}
                >
                    <ModalWrapper onClick={e => e.stopPropagation()}>
                        <p>Importante!</p>

                        <ModalContent>
                            <RemovingElementWrap>
                                <span>
                                    Antes de iniciar suas compras,{' '}
                                    <strong>
                                        realize o seu login no sistema
                                    </strong>{' '}
                                    para uma experiência personalizada.
                                </span>

                                <ButtonsWrap>
                                    <BigButton
                                        color="primary"
                                        bgColor="secondary"
                                        onClick={() => setVisible(false)}
                                        allWidth
                                    >
                                        Cancelar
                                    </BigButton>
                                    <BigButton
                                        color="primary"
                                        bgColor="primary"
                                        onClick={() => {
                                            setIsVisibleAuthModal(true, 'login');
                                            setVisible(false)
                                        }}
                                        allWidth
                                    >
                                        Fazer login
                                    </BigButton>
                                </ButtonsWrap>
                            </RemovingElementWrap>
                        </ModalContent>
                    </ModalWrapper>
                </BackgroundModal>
            )}
        </AnimatePresence>,
        document.body
    );
};
